function noop() {
    // no op
}
/**
 * Util to check if component is currently mounted
 *
 * @param component
 * @param ReactDOM
 */
function isMounted(component, ReactDOM) {
    try {
        return !!ReactDOM.findDOMNode(component);
    }
    catch (error) {
        // Error: Unable to find node on an unmounted component.
        return false;
    }
}
/**
 * Instantiates a react class bound to the Zoid component
 * that will delegate rendering to the client installed React and ReactDOM instances.
 *
 * @param init
 * @param React
 * @param ReactDOM
 * @constructor
 */
export const ZoidReactDriver = ({ init, React, ReactDOM, }) => class ZoidReactComponent extends React.Component {
    render() {
        return React.createElement('div', null);
    }
    componentDidMount() {
        const el = ReactDOM.findDOMNode(this);
        const parent = init({ ...(this.props || {}) });
        parent.render(el, 'iframe').catch((error) => {
            // component did not render successfully
            // probably because it was closed abruptly, or destroyed.
            // So we check first if component is still mounted,
            // and only then we re-throw the error as setState to allow it
            // to be handled by an upper ErrorBoundary.
            if (!isMounted(this, ReactDOM)) {
                // no longer mounted, so we safely ignore the error.
                return;
            }
            this.setState(() => {
                throw error;
            });
        });
        this.setState({ parent });
    }
    componentDidUpdate() {
        if (this.state && this.state.parent) {
            this.state.parent.updateProps({ ...(this.props || {}) }).catch(noop);
        }
    }
};
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiWm9pZFJlYWN0RHJpdmVyLmpzIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiLi4vLi4vLi4vc3JjL2xpYi9ab2lkUmVhY3REcml2ZXIudHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBZUEsU0FBUyxJQUFJO0lBQ1gsUUFBUTtBQUNWLENBQUM7QUFFRDs7Ozs7R0FLRztBQUNILFNBQVMsU0FBUyxDQUNoQixTQUE2QixFQUM3QixRQUE0QjtJQUU1QixJQUFJO1FBQ0YsT0FBTyxDQUFDLENBQUMsUUFBUSxDQUFDLFdBQVcsQ0FBQyxTQUFTLENBQUMsQ0FBQztLQUMxQztJQUFDLE9BQU8sS0FBSyxFQUFFO1FBQ2Qsd0RBQXdEO1FBQ3hELE9BQU8sS0FBSyxDQUFDO0tBQ2Q7QUFDSCxDQUFDO0FBRUQ7Ozs7Ozs7O0dBUUc7QUFDSCxNQUFNLENBQUMsTUFBTSxlQUFlLEdBQUcsQ0FBQyxFQUM5QixJQUFJLEVBQ0osS0FBSyxFQUNMLFFBQVEsR0FLVCxFQUFFLEVBQUUsQ0FDSCxNQUFNLGtCQUFtQixTQUFRLEtBQUssQ0FBQyxTQUFtQztJQUN4RSxNQUFNO1FBQ0osT0FBTyxLQUFLLENBQUMsYUFBYSxDQUFDLEtBQUssRUFBRSxJQUFJLENBQUMsQ0FBQztJQUMxQyxDQUFDO0lBRUQsaUJBQWlCO1FBQ2YsTUFBTSxFQUFFLEdBQUcsUUFBUSxDQUFDLFdBQVcsQ0FBQyxJQUFJLENBQUMsQ0FBQztRQUN0QyxNQUFNLE1BQU0sR0FBRyxJQUFJLENBQUMsRUFBRSxHQUFHLENBQUMsSUFBSSxDQUFDLEtBQUssSUFBSSxFQUFFLENBQUMsRUFBRSxDQUFDLENBQUM7UUFDL0MsTUFBTSxDQUFDLE1BQU0sQ0FBQyxFQUFFLEVBQUUsUUFBUSxDQUFDLENBQUMsS0FBSyxDQUFDLENBQUMsS0FBSyxFQUFFLEVBQUU7WUFDMUMsd0NBQXdDO1lBQ3hDLHlEQUF5RDtZQUN6RCxtREFBbUQ7WUFDbkQsOERBQThEO1lBQzlELDJDQUEyQztZQUMzQyxJQUFJLENBQUMsU0FBUyxDQUFDLElBQUksRUFBRSxRQUFRLENBQUMsRUFBRTtnQkFDOUIsb0RBQW9EO2dCQUNwRCxPQUFPO2FBQ1I7WUFDRCxJQUFJLENBQUMsUUFBUSxDQUFDLEdBQUcsRUFBRTtnQkFDakIsTUFBTSxLQUFLLENBQUM7WUFDZCxDQUFDLENBQUMsQ0FBQztRQUNMLENBQUMsQ0FBQyxDQUFDO1FBQ0gsSUFBSSxDQUFDLFFBQVEsQ0FBQyxFQUFFLE1BQU0sRUFBRSxDQUFDLENBQUM7SUFDNUIsQ0FBQztJQUVELGtCQUFrQjtRQUNoQixJQUFJLElBQUksQ0FBQyxLQUFLLElBQUksSUFBSSxDQUFDLEtBQUssQ0FBQyxNQUFNLEVBQUU7WUFDbkMsSUFBSSxDQUFDLEtBQUssQ0FBQyxNQUFNLENBQUMsV0FBVyxDQUFDLEVBQUUsR0FBRyxDQUFDLElBQUksQ0FBQyxLQUFLLElBQUksRUFBRSxDQUFDLEVBQUUsQ0FBQyxDQUFDLEtBQUssQ0FBQyxJQUFJLENBQUMsQ0FBQztTQUN0RTtJQUNILENBQUM7Q0FDRixDQUFDIn0=